export default "__VITE_ASSET__CGm1941L__"